// extracted by mini-css-extract-plugin
export default {"container":"Ready_container__IOQlP","text":"Ready_text__54rH5"};